import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { Card, Spinner } from "react-bootstrap";
import { AdmPanelContainer } from "../../../../adm-panel/site/api/screens";
import { AdsListPageControllerImpl, AdsStrings } from "../../../business";
import { AdsListDataResponse } from "../../interfaces";
import { AdsListPageFactoryImpl } from "../factories";

export const AdsListPage: React.FC = () => {
  const strings = AdsStrings['PTBR'].list;
  const [isLoading, setLoading] = useState<Boolean>(true);
  const [adsList, setAdsList] = useState<AdsListDataResponse>();

  const factory = new AdsListPageFactoryImpl();
  const controller = new AdsListPageControllerImpl();

  const fetchData = async () => {
    try {
      const response = await controller.onLoad();
      setLoading(false);
      setAdsList(response);
    } catch (error) {
      console.error("Erro na requisição:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const content =
    <> <h4 className="mb-4">{strings.title}</h4>
      <Card>
        <Card.Body>
          {isLoading ? <Spinner animation="border" variant="primary" /> : factory.create(adsList)}
        </Card.Body>
      </Card>
    </>

  return <AdmPanelContainer children={content} />
}
